import { useState, useEffect } from 'react';

// Mock data for notifications
const MOCK_USERS = [
  { name: "Max", city: "Deutschland" },
  { name: "Sophie", city: "Österreich" },
  { name: "Leon", city: "Schweiz" },
  { name: "Emma", city: "Deutschland" },
  { name: "Finn", city: "Deutschland" },
  { name: "Mia", city: "Österreich" },
  { name: "Luca", city: "Italien" },
  { name: "Hannah", city: "Deutschland" },
  { name: "Paul", city: "Belgien" },
  { name: "Lena", city: "Deutschland" }
];

const MOCK_ACTIVITIES = [
  "hat sich angemeldet",
  "hat die 100 CPM Marke geknackt",
  "hat 10 Übungen abgeschlossen",
  "hat ein neues Abzeichen freigeschaltet",
  "hat eine Übung mit 0% Fehlerquote abgeschlossen"
];

// Generate a random notification
const generateMockNotification = () => {
  const user = MOCK_USERS[Math.floor(Math.random() * MOCK_USERS.length)];
  const activity = MOCK_ACTIVITIES[Math.floor(Math.random() * MOCK_ACTIVITIES.length)];
  const timeAgo = Math.floor(Math.random() * 15) + 1; // 1-15 minutes ago
  
  return {
    id: Date.now(), // Use timestamp as unique ID
    user: user.name,
    city: user.city, 
    activity,
    timeAgo
  };
};

const ActivityNotification = ({ firebaseNotifications = [] }) => {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [useMockData, setUseMockData] = useState(true);
  
  // Function to toggle between real and mock data
  const toggleDataSource = () => {
    // This would be used only in development
    if (process.env.NODE_ENV === 'development') {
      setUseMockData(prev => !prev);
    }
  };
  
  useEffect(() => {
    // Function to show a new notification
    const showNotification = () => {
      let notification;
      
      if (useMockData || firebaseNotifications.length === 0) {
        // Use mock data
        notification = generateMockNotification();
      } else {
        // Use real data from Firebase
        const randomIndex = Math.floor(Math.random() * firebaseNotifications.length);
        notification = firebaseNotifications[randomIndex];
      }
      
      setCurrentNotification(notification);
      setIsVisible(true);
      
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    
    // Show notifications regularly
    const interval = setInterval(() => {
      // 30% chance to show a notification
      if (Math.random() < 0.3) {
        showNotification();
      }
    }, 10000); // Check every 10 seconds
    
    // Show first notification after 5 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    
    // Clean up
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, [firebaseNotifications, useMockData]);
  
  return (
    <div 
      className="fixed bottom-4 left-4 bg-white border border-gray-200 rounded-lg shadow-lg p-4 max-w-sm transition-opacity duration-500 z-50"
      style={{ 
        opacity: (isVisible && currentNotification) ? 1 : 0,
        visibility: (isVisible && currentNotification) ? 'visible' : 'hidden',
        height: '80px',
        width: '300px' 
      }}
      aria-live="polite"
      aria-atomic="true"
    >
      <div className="flex items-center">
        <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-500 mr-3">
          {currentNotification?.user ? currentNotification.user.charAt(0).toUpperCase() : '?'}
        </div>
        <div>
          <p className="text-sm">
            <span className="font-semibold">{currentNotification?.user || 'Jemand'}</span> aus <span className="font-medium">{currentNotification?.city || 'Deutschland'}</span>{' '}
            {currentNotification?.activity || 'ist aktiv'}
          </p>
          <p className="text-xs text-gray-500 mt-1">
            vor {currentNotification?.timeAgo || 1} Minuten
          </p>
        </div>
      </div>
    </div>
  );
};

export default ActivityNotification;